<mat-dialog-content>
    <iframe *ngIf="documentBlobUrl" [src]="documentBlobUrl" width="100%" height="500px" style="border: none;"></iframe>
  </mat-dialog-content>
  
  <div style="display: flex; justify-content: flex-end; padding: 10px;">
    <button mat-button (click)="closeDialog()">Close</button>
  </div>
  